import Work1 from "../../assets/char.png";
import Work2 from "../../assets/bakry.png";
import Work3 from "../../assets/mos3d.png";
import Work4 from "../../assets/udacity.png";
import Work5 from "../../assets/cs50.png";
import Work6 from "../../assets/ibm.png";
import Work7 from "../../assets/work7.png";
import Work8 from "../../assets/work8.png";
import Work9 from "../../assets/ai.png";
import Work10 from "../../assets/cars.png";
import Work11 from "../../assets/pricewise.png";
import Work12 from "../../assets/house.png";
import Work13 from "../../assets/gym.png";
import udacity from "../../assets/web.pdf";

export const projectsData = [
  {
    id: 1,
    image: Work2,
    title: "Bakery",
    link: "https://muhammedahmedanwar.github.io/bakery/",
    category: "websites",
  },
  {
    id: 2,
    image: Work1,
    title: "Charity",
    link: "https://muhammedahmedanwar.github.io/charity/",
    category: "websites",
  },
  {
    id: 3,
    image: Work3,
    title: "Movies",
    link: "https://muhammedahmedanwar.github.io/movies/",
    category: "websites",
  },
  {
    id: 7,
    image: Work7,
    title: "Restaurant",
    link: "https://restaurant-snowy-five.vercel.app/",
    category: "websites",
  },
  {
    id: 8,
    image: Work8,
    title: "GPT3",
    link: "https://gpt3-rho-two.vercel.app/",
    category: "websites",
  },
  {
    id: 9,
    image: Work9,
    title: "AI-Summarize",
    link: "https://ai-summarize-beta.vercel.app/",
    category: "websites",
  },
  {
    id: 12,
    image: Work12,
    title: "Real Estate",
    link: "https://house-muhammedahmedanwar.vercel.app/",
    category: "websites",
  },
  {
    id: 10,
    image: Work10,
    title: "RentCArs",
    link: "https://rentcars-ten.vercel.app/",
    category: "websites",
  },
  {
    id: 13,
    image: Work13,
    title: "Gym",
    link: "https://online-gym-muhammedahmedanwar.vercel.app/",
    category: "websites",
  },
  {
    id: 11,
    image: Work11,
    title: "PriceWise",
    link: "https://pricewise-o8u5zsc4a-muhammedahmedanwar.vercel.app/",
    category: "websites",
  },
  {
    id: 4,
    image: Work4,
    title: "Udacity",
    link: udacity,
    category: "certificate",
  },
  {
    id: 5,
    image: Work5,
    title: "Cs50",
    link: "https://certificates.cs50.io/37e2fc79-90de-407e-97e8-bdaad94f18d0.pdf?size=letter",
    category: "certificate",
  },
  {
    id: 6,
    image: Work6,
    title: "IBM",
    link: "https://www.credly.com/badges/db7a5037-20b4-4cfb-9bae-b017d0ce489a/print",
    category: "certificate",
  },
];

export const projectsNav = [
  {
    name: "websites",
  },

  {
    name: "certificate",
  },
];
